export const viewCaseShowLimit = 20;
